<template>
    <el-dialog
        :title="isForm ? (formId ? '编辑' : '添加部门') : '查看'"
        width="640px"
        :model-value="modelValue"
        @close="closed"
        :close-on-click-modal="false"
    >
        <el-form ref="formRef" :model="formData" :rules="isForm ? formRules : []" label-width="120px" style="max-width: 540px">
            <el-form-item label="上级部门" prop="parent" v-if="formData.parent != null">
                <el-tree-select
                    v-if="isForm"
                    v-show="isForm"
                    v-model="formData.parent"
                    :data="deptOptionLists"
                    check-strictly
                    :render-after-expand="false"
                    value-key="name"
                    node-key="id"
                    placeholder="选择上级部门"
                    :default-expanded-keys="[deptOptionLists[0].id]"
                    style="width: 100%"
                    :props="{ label: 'name' }"
                    filterable
                    :filter-node-method="filterMethod"
                >
                    <template #default="{ data }">
                        {{ data.name }}
                        <span v-if="data.children" style="color: gray"></span>
                        <!-- ({{ data.children.length }}) -->
                    </template>
                </el-tree-select>
                <span v-else>{{ formData.id }}</span>
            </el-form-item>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="名称" prop="name">
                        <el-input v-if="isForm" v-model="formData.name" placeholder="请输入名称"></el-input>
                        <span v-else>{{ formData.name }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="显示排序" prop="list_order">
                        <el-input-number
                            v-if="isForm"
                            v-model="formData.list_order"
                            class="mx-4"
                            :min="0"
                            :max="999999"
                            controls-position="right"
                        />
                        <span v-else>{{ formData.list_order }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="负责人" prop="leader">
                        <el-input v-if="isForm" v-model="formData.leader" placeholder="请输入负责人"></el-input>
                        <span v-else>{{ formData.leader }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="联系电话" prop="phone">
                        <el-input v-if="isForm" v-model="formData.phone" placeholder="请输入联系电话"></el-input>
                        <span v-else>{{ formData.phone }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="邮箱" prop="email">
                        <el-input v-if="isForm" v-model="formData.email" placeholder="请输入邮箱"></el-input>
                        <span v-else>{{ formData.email }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="状态">
                        <el-radio-group v-if="isForm" v-model="formData.status">
                            <el-radio :value="1">正常</el-radio>
                            <el-radio :value="0">停用</el-radio>
                        </el-radio-group>
                        <div v-else>{{ formData.status ? '正常' : '停用' }}</div>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closed">取消</el-button>
                <el-button v-if="isForm" type="primary" :loading="submitLoading" @click="onConfirm">确定</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script setup>
import { defineEmits, defineProps, ref, watch } from 'vue'
import { addDepartment, getDepartmentDetail, putDepartment } from '@/api/dept.js'
import { ElMessage } from 'element-plus'
import { validateEMail, validatePhone } from '@/utils/rules.js'

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    isForm: {
        type: Boolean,
        default: false
    },
    formId: {
        type: String,
        required: false
    },
    parentId: {
        type: String,
        required: false
    },
    deptOptionLists: {
        type: Array,
        required: true
    }
})
const emits = defineEmits(['update:modelValue', 'updateForm'])

// 表单源
const formData = ref({
    parent: '',
    name: '',
    leader: '',
    phone: '',
    email: '',
    list_order: 1,
    status: 1,
    visible: 1
})
// 验证规则

const formRules = ref({
    parent: [
        {
            required: true,
            trigger: 'blur',
            message: '请选择上级部门'
        }
    ],
    name: [
        {
            required: true,
            trigger: 'blur',
            message: '请输入部门名称'
        }
    ],
    list_order: [
        {
            required: true,
            trigger: 'blur',
            message: '请输入显示排序'
        }
    ],
    phone: [{ validator: validatePhone, trigger: 'blur' }],
    email: [{ validator: validateEMail, trigger: 'blur' }]
})
const dialogTitle = ref('')
const submitLoading = ref(false)
const formRef = ref(null)
/**
 * 关闭
 */
const closed = () => {
    dialogTitle.value = ''
    emits('update:modelValue', false)
    formRef.value.resetFields()
}

/**
  确定按钮点击事件
 */

const onConfirm = async () => {
    if (!props.isForm) return
    if (props.formId !== '') {
        await doputDepartment()
    } else {
        await doaddDepartment()
    }
}

// 修改部门
const doputDepartment = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        try {
            await putDepartment(formData.value)
            // 部门修改成功
            emits('updateForm')
            ElMessage.success('修改成功！')
            submitLoading.value = false
            closed()
        } catch (error) {
            submitLoading.value = false
        }
    })
}

// 添加部门
const doaddDepartment = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        try {
            await addDepartment(formData.value)
            // 部门添加成功
            emits('updateForm')
            ElMessage.success('添加成功！')
            submitLoading.value = false
            closed()
        } catch (error) {
            submitLoading.value = false
        }
    })
}

// 获取部门详情
const getDepartmentDetailFun = async () => {
    const data = await getDepartmentDetail(props.formId)
    dialogTitle.value = '-' + data.name
    formRef.value.resetFields()
    formData.value = {
        id: data.id,
        parent: data.parent,
        name: data.name,
        leader: data.leader,
        phone: data.phone,
        email: data.email,
        list_order: data.list_order,
        status: data.status,
        visible: data.visible
    }
}

const filterMethod = (value, data) => {
    if (props.formId) {
        return data.id !== props.formId
    } else {
        return true
    }
}

// 只有formId有的时候，才会去请求数据
watch(
    () => props.modelValue,
    (newVal) => {
        if (newVal && props.formId) {
            getDepartmentDetailFun()
        } else {
            formData.value = {
                parent: '',
                name: '',
                leader: '',
                phone: '',
                email: '',
                list_order: 1,
                status: 1,
                visible: 1
            }
        }
        if (newVal && props.parentId) {
            formData.value.parent = props.parentId
        }
    }
)
</script>

<style lang="scss" scoped></style>
